

































import { Component, Vue } from 'vue-property-decorator';
import {GeneralService} from '../services/general-service';
import ProgramLevel from '../components/ProgramLevel.vue';
import config from '../services/api-config';
import router from '../router';
import AuthService from '../services/auth-service';
import EmojiRating from '../components/EmojiRating.vue';

@Component({
  components: {
      'program-level': ProgramLevel,
      EmojiRating
  },
})

export default class SubjectSelect extends Vue {
    private service = new GeneralService();
    public entities = [
        {fullName: 'Education Management System'}, {fullName: 'E-Learning'}
    ];
    private boards: any = [];
    private activated: boolean = false;
    private boardSelected = false;
    private level_id;
    private auth = new AuthService();
    private struckoffpopup: boolean = false;

    private selectApp(name) {
        if (name == 'E-Learning'){
            this.$router.push('/selectEL');
        } else if (name == 'Education Management System'){
            this.$router.push('/selectCMS');
        }
    }

    mounted() {
        this.checkStruckOffStatus();
    }

    private async checkStruckOffStatus() {
        try {
            const username = localStorage.getItem(config.username);
            if (username) {
                const response = await this.service.getInfoEMS(username);
                
                if (response && response.data && response.data.length > 0) {
                    const studentData = response.data[0];
                    console.log('IsStruckOff value:', studentData.IsStruckOff);
                    console.log('IsStruckOff type:', typeof studentData.IsStruckOff);
                    
                    // Strict check for true value
                    if (studentData.IsStruckOff === true || studentData.IsStruckOff === 'true' || studentData.IsStruckOff === 1) {
                        console.log('Setting struckoffpopup to true');
                        this.struckoffpopup = true;
                    } else {
                        console.log('IsStruckOff is false, not showing popup');
                        this.struckoffpopup = false;
                    }
                }
            }
        } catch (error) {
            console.error('Error checking struck off status:', error);
        }
    }

}
